import features from '@evidentid/browser-framework/features';

export default features(window);
